import mantenimiento1 from '../../../../assets/img/desktop/8e3de025-3a0f-4e95-b160-3a052ef52ace.jpg';
import mantenimiento2 from '../../../../assets/img/desktop/dc64fe59-c60d-473a-9d6f-f2d3d5f87f91.jpg';
import './CMMantenimientoIndustrial.css';

function CMMantenimientoIndustrial() {

    return (
        <div id="CMMantenimientoIndustrial">
            <section id="MI__head">
                <h2>Mantenimiento Industrial</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Mantenimiento Industrial</li>
                </ul>
            </section>
            <section id="MI__section2">
                <figure id="MI-content">
                    <img src={mantenimiento1} alt="Mantenimiento de Equipos Hidráulicos" />
                </figure>
                <div id="MI-text">
                    <p id="MI-text__p1">Equipos hidráulicos y sistemas críticos<strong> para garantizar un rendimiento óptimo y continuo.</strong></p>
                    <p id="MI-text__p2">Ofrecemos servicios de mantenimiento preventivo y correctivo para equipos hidráulicos industriales y logísticos como stocas, coches picking, 
                        apiladores, transpaletas y plataformas elevadoras. Nuestros trabajos son ejecutados por técnicos especializados y certificados, siguiendo 
                        procedimientos técnicos y normas de seguridad industrial.</p>
                </div>
            </section>
            <section id="MI__section3">
                <div id="MIs3-content1">
                    <div id="MI3-content1__text">
                        <p id="MI3-content1__text--p1">A través de nuestro modelo de entrega único, <strong>INFRASOL</strong> provee servicios rentables; basados en Acuerdos de Niveles de Servicio (SLAs); soportados
                            por una metodología de entrega madura, alineada a las mejores prácticas y soportado en un sólido programa de calidad.</p>
                        <p id="MI3-content1__text--p2">Contamos con experiencia en planificación, diseño, implementación y gestión de proyectos de mantenimiento industrial
                            para resolver los requerimientos técnicos o de negocios específicos de clientes, integrando tecnología y servicios.</p>
                        <p id="MI3-content1__text--p3">Nuestros servicios garantizan mayor confiabilidad y disponibilidad operativa de los equipos, reducción de fallas inesperadas y paradas de planta, 
                            ahorro en costos de reparación y prolongación de la vida útil del sistema, y optimización del rendimiento hidráulico y eficiencia energética.</p>
                        <p id="MI3-content1__text--p4">Equipos atendidos y servicios incluidos:</p>
                    </div>
                    <div id="MI3-content1__image">
                        <figure>
                            <img src={mantenimiento2} alt="Mantenimiento de Equipos Hidráulicos" />
                        </figure>
                    </div>
                </div>
                <div id="MIs3-content2">
                    <div id="MIs3-content2__text1">
                        <div id="MIs3-content2__text1--i1">
                            <h3>Equipos Atendidos</h3>
                            <div></div>
                            <p>Stocas y apiladores hidráulicos o eléctricos, coches picking y transpaletas manuales e hidráulicas, plataformas elevadoras, 
                                montacargas y mesas hidráulicas, prensas hidráulicas y sistemas de elevación industrial.</p>
                        </div>
                        <div id="MIs3-content2__text1--i2">
                            <h3>Servicios de Mantenimiento</h3>
                            <div></div>
                            <p>Diagnóstico técnico y revisión integral del sistema hidráulico, limpieza, lubricación y verificación de fugas o desgastes, 
                                reemplazo de sellos, mangueras, válvulas y bombas, flushing y filtrado del aceite hidráulico para eliminar contaminantes, 
                                y calibración de presión, caudal y controles de operación.</p>
                        </div>
                    </div>
                    <div id="MIs3-content2__text2">
                        <h3 id="MIs3-content2__text2--i3">Beneficios Clave</h3>
                        <div></div>
                        <ul>
                            <li>Mayor confiabilidad y disponibilidad operativa de los equipos.</li>
                            <li>Reducción de fallas inesperadas y paradas de planta.</li>
                            <li>Ahorro en costos de reparación y prolongación de la vida útil del sistema.</li>
                            <li>Cumplimiento de normas de seguridad industrial y estándares del fabricante.</li>
                            <li>Optimización del rendimiento hidráulico y eficiencia energética.</li>
                            <li>Asistencia técnica en planta y soporte postservicio.</li>
                            <li>Suministro e instalación de repuestos originales o certificados.</li>
                            <li>Mantenimiento eléctrico complementario en equipos electrohidráulicos.</li>
                            <li>Emisión de informes técnicos con registro de parámetros y recomendaciones.</li>                        
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default CMMantenimientoIndustrial;

